import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'teamState';

export const getAllTeams = createAsyncThunk(
    'teamState/getAllTeams',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/team`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            console.log('ERROR FETCHING TEAMS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    teams: [],
    loading: {
        getAll: false,
    },
};

const teamSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTeams.pending, (state) => {
                state.loading.getAll = true;
                state.error = null; 
            })
            .addCase(getAllTeams.fulfilled, (state, action) => {
                state.loading.getAll = false;
                state.teams = action.payload;
            })
            .addCase(getAllTeams.rejected, (state, action) => {
                state.loading.getAll = false;
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export default teamSlice.reducer;